module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjIyIiBoZWlnaHQ9IjIyIiBmaWxsPSIjNzg4QTlGIiBmaWxsLW9wYWNpdHk9Ii4wNCIgcng9IjExIi8+CiAgICAgICAgPHBhdGggZmlsbD0iIzc3OEI5RiIgZD0iTTkuNDI4IDcuNDg4bDMuMTcyIDIuOTU4LTIuOTU4IDMuMTcyLjk2NS45IDMuODU4LTQuMTM3LTQuMTM3LTMuODU4eiIvPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/controls/calendar-next.svg
// module id = ./src/assets/controls/calendar-next.svg
// module chunks = 0